<template>
  <section>
    <div class="modal-body">
      <form @submit.prevent="submitForm" class="m-form m-form--state" >
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <div class="col-lg-6">
              <label>{{ 'entrance_name' | capitalize }}</label>
              <input type="text" id="entrance_name_req" v-model="log.device" readonly name="entrance_name_req" class="form-control m-input" >
            </div>
            <div class="col-lg-6">
              <label>{{ 'reference_one' | capitalize }}</label>
              <input type="text" id="reference_one_req" v-model="log.device_reference" readonly name="reference_one_req" class="form-control m-input" >
            </div>
            <div class="col-lg-6">
              <label>{{ 'url_request' | capitalize }}</label>
              <input type="text" id="url" v-model="log.url" readonly name="url" class="form-control m-input" >
            </div>
            <div class="col-lg-6">
              <label>{{ 'request_made_by' | capitalize }}</label>
              <input type="text" id="remote_ip" v-model="log.remote_ip" readonly name="remote_ip" class="form-control m-input" >
            </div>
          </div>
          <div class="form-group m-form__group row">
            <div class="col-lg-6">
              <label>{{ 'request_made_from' | capitalize }}</label>
              <input type="text" id="remote_location" v-model="log.remote_location" readonly name="remote_location" class="form-control m-input" >
            </div>
            <div class="col-lg-6">
              <label>{{ 'user' | capitalize }}</label>
              <input type="text" id="user_req" v-model="log.user" readonly name="user_req" class="form-control m-input" >
            </div>
          </div>
          <div class="form-group m-form__group row">
            <div class="col-lg-6">
              <label>{{ 'request_status' | capitalize }}</label>
              <textarea v-model="log.request_result" readonly name="request_result" rows="4" class="form-control form-control-danger m-input"></textarea>
            </div>
            <div class="col-lg-6">
              <label>{{ 'request_made_at' | capitalize }}</label>
              <input type="text" id="created_at_req" v-model="log.created_at" readonly name="created_at_req" class="form-control m-input" >
            </div>
          </div>
          <div class="form-group m-form__group row">
            <div class="col-lg-12">
              <label>{{ 'implicated_data' | capitalize }}</label>
              <textarea v-model="log.implicated_data" readonly name="data" rows="3" class="form-control form-control-danger m-input"></textarea>
            </div>
          </div>          
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="setStatusLogModal(false)" id="btn-cancel">
        {{'close' | capitalize }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: { data: Object },
  data () {
    return {
      log: {}
    }
  },
  computed: {
    ...mapGetters({modal: 'getStatusLogModal'})
  },
  methods: {
    ...mapActions(['setStatusLogModal', 'getUserName'])
  },
  watch: {
    modal (newVal, oldVal) {
      const self = this
      if (oldVal === false && newVal === true) {
        this.$nextTick(() => {
          self.log = self.data
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// Base_req.vue